module.exports = __webpack_public_path__ + "img/green-5-mb.b731e733.png";